import { setInventoryStandard } from "@/apis/product";
import ProductDesc from "@/components/Desc/ProductDesc";
import { ProductSelect } from "@/components/Selector";
import { numFormmater } from "@/pages/Requirement/util";
import { AddInventoryStandard, InventoryStandard } from "@/types/product";
import { Flex, Form, InputNumber, Modal, notification } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface BaseProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (data: InventoryStandard, type: "ADD" | "EDIT") => void;
  readonly?: boolean;
};
interface AddProps {
  formType: "ADD";
  detail: undefined;
};
interface EditProps {
  formType: "EDIT";
  detail: InventoryStandard;
};

type AddOrEditProps = (BaseProps & AddProps) | (BaseProps & EditProps);

const AddOrEdit: FC<AddOrEditProps> = ({ open, onClose, onSuccess, readonly = false, formType, detail }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<AddInventoryStandard>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (formType === "EDIT") {
      form.setFieldsValue({
        productId: detail.product.id,
        minStockCount: detail.minStockCount,
        maxStockCount: detail.maxStockCount,
        maxStockAgeDays: detail.maxStockAgeDays,
        minStockAgeDays: detail.minStockAgeDays,
      })
    }
  }, [formType, detail])

  const handleSubmit = (values: AddInventoryStandard) => {
    if (loading) return
    if (!!!values.productId) return notification.error({ message: t("components.plProduct") });
    setLoading(true);
    setInventoryStandard({ ...values })
      .then(res => {
        notification.success({ message: t('common.saveOk') })
        onSuccess({ ...res }, formType)
      })
      .catch(err => {
        notification.success({ message: t('common.saveFAil') })
      })
      .finally(() => setLoading(false))
  };

  const handleChange = (val: number | null, key: keyof AddInventoryStandard) => {
    let value = val || 0;
    if (key === "minStockCount") {
      let max = form.getFieldValue("maxStockCount") as number;
      if (value > max) form.setFieldValue("maxStockCount", value)
    }
    if (key === "maxStockCount") {
      let min = form.getFieldValue("minStockCount") as number;
      if (value < min) form.setFieldValue("minStockCount", value)
    }
    if (key === "minStockAgeDays") {
      let max = form.getFieldValue("maxStockAgeDays") as number;
      if (value > max) form.setFieldValue("maxStockAgeDays", value)
    }
    if (key === "maxStockAgeDays") {
      let min = form.getFieldValue("minStockAgeDays") as number;
      if (value < min) form.setFieldValue("minStockAgeDays", value)
    }
  }

  return (
    <Modal title={t(formType === "ADD" ? "product.alertAdd" : "product.alertDetail")}
      open={open}
      onCancel={onClose}
      onOk={form.submit}
      width={formType === "EDIT" ? 1000 : 600}
      okButtonProps={{ loading }}
    >
      <Flex vertical style={{ width: "100%" }}>
        <Form<AddInventoryStandard> form={form} onFinish={handleSubmit} disabled={readonly}>
          <Form.Item<AddInventoryStandard> name="productId" label={t('product.productInfo')} noStyle={formType === "EDIT"} >
            {formType === "EDIT" ? <ProductDesc product={detail.product} /> : <ProductSelect onlyPreReady />}
          </Form.Item>
          <Form.Item<AddInventoryStandard> name="minStockCount" label={t('product.minStockCount')} style={formType === "EDIT" ? { marginTop: 8 } : undefined} >
            <InputNumber changeOnWheel
              size="large"
              formatter={val => numFormmater(Number(val || 0))}
              min={0}
              precision={0}
              style={{ width: "100%" }}
              onChange={(val) => handleChange(val, "minStockCount")}
            />
          </Form.Item>
          <Form.Item<AddInventoryStandard> name="maxStockCount" label={t('product.maxStockCount')} >
            <InputNumber changeOnWheel
              size="large"
              formatter={val => numFormmater(Number(val || 0))}
              min={0}
              precision={0}
              style={{ width: "100%" }}
              onChange={(val) => handleChange(val, "maxStockCount")}
            />
          </Form.Item>
          <Form.Item<AddInventoryStandard> name="minStockAgeDays" label={t('product.minStockAgeDays')} >
            <InputNumber changeOnWheel
              size="large"
              formatter={val => numFormmater(Number(val || 0))}
              min={0}
              precision={0}
              style={{ width: "100%" }}
              onChange={(val) => handleChange(val, "minStockAgeDays")}
            />
          </Form.Item>
          <Form.Item<AddInventoryStandard> name="maxStockAgeDays" label={t('product.maxStockAgeDays')} >
            <InputNumber changeOnWheel
              size="large"
              formatter={val => numFormmater(Number(val || 0))}
              min={0}
              precision={0}
              style={{ width: "100%" }}
              onChange={(val) => handleChange(val, "maxStockAgeDays")}
            />
          </Form.Item>
        </Form>
      </Flex>
    </Modal>
  );
};

export default AddOrEdit;